// extracted by mini-css-extract-plugin
export default {"KitoBuddy":"styles_KitoBuddy__wj9cX"};